import { NavLink, Link } from 'react-router-dom';
import { themeVal } from '@devseed-ui/theme-provider';
import filterComponentProps from '../utils/filter-component-props';

import styled from 'styled-components';

// Please refer to filterComponentProps to understand why this is needed
const propsToFilter = [
  'variation',
  'size',
  'hideText',
  'useIcon',
  'active',
  'visuallyDisabled',
];

export const StyledNavLink = filterComponentProps(NavLink, propsToFilter);
export const StyledLink = filterComponentProps(Link, propsToFilter);
export const MenuLink = styled(StyledNavLink)`
  font-weight: ${themeVal('type.heading.weight')};
  &:not(.active) {
    color: ${themeVal('color.base')};
  }
  &.active {
    color: ${themeVal('color.primary')};
  }
  &:hover {
    color: ${themeVal('color.primary')};
  }
`;
